import * as z from 'zod';
import { passwordSchema } from '../utils/validators/passwordSchema.ts';
import { phoneNumberSchema } from '../utils/validators/phoneNumberSchema.ts';

export const availableRoles = ['business_provider', 'family_member'] as const;

export const genderOptions = ['male', 'female', 'prefer_not_to_say'] as const;

// UK postcode regex, covers full postcodes and outward-only codes.
const UK_POSTCODE_REGEX =
  /^(GIR ?0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y])?)|[0-9][A-HJKPSTUW])( ?[0-9][ABD-HJLNP-UW-Z]{2})?)$/i;

export const registerUserSchema = z.object({
  first_name: z.string().min(1, { message: 'First name is required.' }),
  last_name: z.string().min(1, { message: 'Last name is required.' }),
  gender: z.enum(genderOptions).optional(),
  phone_number: phoneNumberSchema,
  city_town: z.string().optional(),
  postcode: z
    .string()
    .min(1, { message: 'Postcode is required.' })
    .refine((value) => UK_POSTCODE_REGEX.test(value.trim()), { message: 'Enter a valid UK postcode.' }),
  email: z.string().min(1, { message: 'This field is required.' }).email('Invalid email'),
  password: passwordSchema,
  roles: z.array(z.enum(availableRoles)).optional(),
});

export type RegisterUserRequest = z.infer<typeof registerUserSchema>;
